import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const MarketPaginationPageSize = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketInternalPaginationPageSizeChange = createEvent(this, "marketInternalPaginationPageSizeChange", 7);
    this.value = undefined;
    this.pageSizeOptions = undefined;
  }
  listSelectionEventHander(e) {
    const { newSelectionValue } = e.detail;
    this.marketInternalPaginationPageSizeChange.emit({
      value: newSelectionValue,
    });
  }
  render() {
    const MarketButtonDropdownTagName = getNamespacedTagFor('market-button-dropdown');
    const MarketFilterButtonTagName = getNamespacedTagFor('market-filter-button');
    const MarketListTagName = getNamespacedTagFor('market-list');
    const MarketRowTagName = getNamespacedTagFor('market-row');
    return (h(Host, { class: "market-pagination-page-size" }, h(MarketButtonDropdownTagName, { "no-caret": true, "popover-placement": "bottom-start", "persist-list": true }, h(MarketFilterButtonTagName, { size: "small", slot: "trigger" }, h("span", null, h("slot", { name: "page-size-label" }, "Results per page")), h("span", { slot: "feedback" }, h("slot", { name: "page-size-feedback" }, this.value))), h(MarketListTagName, { value: this.value, slot: "content" }, this.pageSizeOptions.split(',').map((v) => (h(MarketRowTagName, { key: `pageSize_${v}`, value: v }, v)))))));
  }
  get el() { return getElement(this); }
};

export { MarketPaginationPageSize as market_pagination_page_size };
